enum PaymentMethod {
    Visa = 'VIS',
    MasterCard = 'ECA',
    Amex = 'AMX',
    DinersClub = 'DIN',
    JCB = 'JCB',
    UnionPay = 'CUP',
    Discover = 'DIS',
    ELO = 'ELO',
}

export default PaymentMethod;
